export const CommonProcessingJobCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Elaborazione Job',
    path: '/sistema/elaborazione-job',
  },
];
